import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    name: 'fliterStabilizedEtpa'
})
export class FliterStabilizedEtpaPipe implements PipeTransform {
    transform(value, status) {
        if (value) {
            if (status && status === 'Stabalized') {
                return value;
            } else {
                return value.filter(item => item.code === 'MR');
            }
        }
    }
}
